<ng-template #template let-anchor>
    <span>{{ anchor.nativeElement.innerText }}</span>
</ng-template>
<div
    class="loader-wrapper"
    kendoTooltip
    showOn="none"
    filter=".k-grid"
    [tooltipTemplate]="template"
    (mouseover)="showTooltip($event)">
    <app-loader [isBusy]="isBusy">
        <ng-template>
            <kendo-grid
                [data]="itemsGridView"
                [skip]="itemPage.skip"
                [pageSize]="itemPage.pageSize"
                [pageable]="pagingOptions"
                [sortable]="{ allowUnsort: allowUnsort, mode: multiple ? 'multiple' : 'single' }"
                [sort]="sort"
                [resizable]="true"
                (pageChange)="pageChange($event, actionStatusChanges)"
                (sortChange)="sortChange($event, actionStatusChanges)">
                @if (
                    hasPermission('PcsApprovals.PcsApprovals.Edit') &&
                    (canSendApproval ||
                        canSend2ndApproval ||
                        canSend3rdApproval ||
                        canComplete ||
                        canApprove ||
                        canReject ||
                        canDelete ||
                        canOnHold)
                ) {
                    <ng-template kendoGridToolbarTemplate>
                        @if (canSendApproval) {
                            <button class="btn btn-sm btn-primary mr-2" (click)="changeStatus('sendApproval')">
                                <fa-icon [icon]="['fas', 'dice-one']"></fa-icon>
                                &nbsp;&nbsp;{{ 'Send for Approval' | translate }}
                            </button>
                        }
                        @if (canSend2ndApproval) {
                            <button class="btn btn-sm btn-primary mr-2" (click)="changeStatus('send2ndApproval')">
                                <fa-icon [icon]="['fas', 'dice-two']"></fa-icon>
                                &nbsp;&nbsp;{{ 'Send for 2nd Approval' | translate }}
                            </button>
                        }
                        @if (canSend3rdApproval) {
                            <button class="btn btn-sm btn-primary mr-2" (click)="changeStatus('send3rdApproval')">
                                <fa-icon [icon]="['fas', 'dice-three']"></fa-icon>
                                &nbsp;&nbsp;{{ 'Send for 3rd Approval' | translate }}
                            </button>
                        }
                        @if (canComplete) {
                            <button
                                class="btn btn-sm btn-light mr-2"
                                [disabled]="['CRT', 'COM', 'CAN'].includes(generalActStatusId)"
                                (click)="changeStatus('complete')">
                                <fa-icon [icon]="['fas', 'check']"></fa-icon>
                                &nbsp;&nbsp;{{ 'Complete' | translate }}
                            </button>
                        }
                        @if (showApproveButtons) {
                            @if (canApprove) {
                                <button class="btn btn-sm btn-success mr-2" (click)="changeStatus('approve')">
                                    <fa-icon [icon]="['fas', 'check']"></fa-icon>
                                    &nbsp;&nbsp;{{ 'Approve' | translate }}
                                </button>
                            }
                            @if (canReject) {
                                <button class="btn btn-sm btn-warning mr-2" (click)="openRejectionRemarkDialog()">
                                    <fa-icon [icon]="['fas', 'times']"></fa-icon>
                                    &nbsp;&nbsp;{{ 'Reject' | translate }}
                                </button>
                            }
                        }
                        @if (canDelete) {
                            <button
                                class="btn btn-sm btn-danger danger mr-2"
                                kendoTooltip
                                title="{{ 'Delete' | translate }}"
                                (click)="changeStatus('delete')">
                                <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                            </button>
                        }
                        @if (canOnHold) {
                            <button class="btn btn-sm btn-secondary mr-2" (click)="changeStatus('onHold')">
                                <fa-icon [icon]="['fas', 'pause-circle']"></fa-icon>
                                &nbsp;&nbsp;{{ 'On Hold' | translate }}
                            </button>
                        }
                    </ng-template>
                }
                <kendo-grid-column title="{{ 'Id' | translate }}" field="id"></kendo-grid-column>
                <kendo-grid-column title="{{ 'From Status' | translate }}" [width]="300">
                    <ng-template kendoGridCellTemplate let-row>
                        @if (row.pcsDocumentAndApprovalFromStatus) {
                            <span>
                                {{
                                    row.pcsDocumentAndApprovalFromStatus.localizedCode +
                                        ' - ' +
                                        row.pcsDocumentAndApprovalFromStatus.name
                                }}
                            </span>
                        }
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="{{ 'To Status' | translate }}" [width]="300">
                    <ng-template kendoGridCellTemplate let-row>
                        @if (row.pcsDocumentAndApprovalToStatus) {
                            <span>
                                {{
                                    row.pcsDocumentAndApprovalToStatus.localizedCode +
                                        ' - ' +
                                        row.pcsDocumentAndApprovalToStatus.name
                                }}
                            </span>
                        }
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="{{ 'Organization For Approval' | translate }}" [width]="300">
                    <ng-template kendoGridCellTemplate let-row>
                        @if (row.forOrganization) {
                            <span>{{ row.forOrganization.name }}</span>
                        }
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="{{ 'Created By Organization' | translate }}" [width]="300">
                    <ng-template kendoGridCellTemplate let-row>
                        @if (row.createdByOrganization) {
                            <span>{{ row.createdByOrganization.name }}</span>
                        }
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="{{ 'Created By' | translate }}" [width]="150">
                    <ng-template kendoGridCellTemplate let-row>
                        @if (row.createdBy) {
                            <span>{{ row.createdBy.firstName + ' ' + row.createdBy.lastName }}</span>
                        }
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="{{ 'Created Date' | translate }}" [width]="300">
                    <ng-template kendoGridCellTemplate let-row>
                        @if (row.createdDate) {
                            <span>{{ row.createdDate | date: 'dd.MM.yyyy HH:mm' }}</span>
                        }
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="{{ 'Terminal ID' | translate }}" [width]="300">
                    <ng-template kendoGridCellTemplate let-row>
                        <span kendoTooltip title="{{ row.terminalName }}">
                            {{ row.terminalId }}
                        </span>
                    </ng-template>
                </kendo-grid-column>
                <ng-template kendoGridNoRecordsTemplate>
                    <p>{{ 'No records available' | translate }}.</p>
                </ng-template>
            </kendo-grid>
        </ng-template>
    </app-loader>
</div>
@if (showChangeOrganization) {
    <kendo-dialog
        title="{{ 'Select organization to send Approval to: ' | translate }}"
        [minWidth]="1150"
        (close)="closeStatusChangeDialogs()">
        @if (showChangeOrganization) {
            <div class="row">
                <kendo-combobox
                    class="no-margin-input"
                    placeholder="{{ 'For Organization' | translate }}"
                    textField="name"
                    valueField="id"
                    [allowCustom]="false"
                    [data]="possibleOrganizationSelections"
                    [value]="sendApprovalDefaultOrganization"
                    [filterable]="true"
                    (selectionChange)="changeSelectedOrganization($event)"
                    (filterChange)="searchOrganizations($event)"></kendo-combobox>
            </div>
        }
        <kendo-dialog-actions layout="end">
            <button
                class="btn btn-sm btn-primary mr-2"
                preventMultiClick
                kendoButton
                [disabled]="!selectedOrganization"
                (click)="newStateTransition()">
                <fa-icon [icon]="['fas', 'check']"></fa-icon>
                &nbsp;&nbsp;{{ 'Submit' | translate }}
            </button>
            <button class="btn btn-sm btn-secondary" kendoButton (click)="closeStatusChangeDialogs()">
                <fa-icon [icon]="['fas', 'times']"></fa-icon>
                &nbsp;&nbsp;{{ 'Cancel' | translate }}
            </button>
        </kendo-dialog-actions>
    </kendo-dialog>
}
@if (rejectionRemarkDialogOpened) {
    <kendo-dialog
        title="{{ 'Add Rejection Remark' | translate }}"
        [minWidth]="550"
        (close)="closeStatusChangeDialogs()">
        <div class="row">
            <span>{{ 'Remark: ' | translate }}</span>
        </div>
        <div class="row">
            <kendo-textarea [rows]="3" [(ngModel)]="remarkValue"></kendo-textarea>
        </div>
        <kendo-dialog-actions layout="end">
            <button class="btn btn-sm btn-primary mr-2" preventMultiClick kendoButton (click)="submitRejectionRemark()">
                <fa-icon [icon]="['fas', 'check']"></fa-icon>
                &nbsp;&nbsp;{{ 'Submit' | translate }}
            </button>
            <button class="btn btn-sm btn-secondary" kendoButton (click)="closeStatusChangeDialogs()">
                <fa-icon [icon]="['fas', 'times']"></fa-icon>
                &nbsp;&nbsp;{{ 'Cancel' | translate }}
            </button>
        </kendo-dialog-actions>
    </kendo-dialog>
}
